<template>
  <div>
      权限不足
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>